import { REGION } from '../app/app.constants';
import store from './store';

const DEFAULT_RAT_SCRIPT = 'https://r.r10s.jp/com/rat/js/rat-main.js';
const DEFAULT_JP_AP_STG_RAT_RECEIVER = 'check.rat.rakuten.co.jp';
const DEFAULT_EU_STG_RAT_RECEIVER = 'check.secure.rat.rakuten.co.jp';

export function initializeRAT(appConfig) {
    const ratScriptSource = appConfig.RAT_URL?.trim() || DEFAULT_RAT_SCRIPT;
    const isRatProd = appConfig.RAT_PROD ?? false;
    const ratScriptTag = document.createElement('script');

    ratScriptTag.src = ratScriptSource;
    ratScriptTag.async = false;
    ratScriptTag.addEventListener('load', function () {
        /*
         * The RAT EU script (rat-eu.js) sets an account-based main receiver during its initialization,
         * which can overwrite any receiver configured before it loads.
         * Executing this logic here ensures our staging receiver is added last to RAL.callQueue
         * and takes precedence — EU uses check.secure.rat.rakuten.co.jp, AP/JP uses check.rat.rakuten.co.jp.
         */
        if (!isRatProd) {
            const receiver =
                appConfig.REGION === REGION.EU
                    ? DEFAULT_EU_STG_RAT_RECEIVER
                    : DEFAULT_JP_AP_STG_RAT_RECEIVER;
            window.RAL = window.RAL || {};
            const RAL = window.RAL;
            RAL.callQueue = RAL.callQueue || [];
            RAL.callQueue.push(['setMainReceiver', receiver]);
        }
        document.dispatchEvent(new Event('SINGLE_PAGE_APPLICATION_LOAD'));
    });
    document.body.appendChild(ratScriptTag);
}

export function addRatEventWithData(data) {
    const appConfig = store.getState().app.appConfig;
    const RAT_ENABLED = appConfig.RAT_ENABLED ?? true;

    if (appConfig && RAT_ENABLED && appConfig.RAT_ACCOUNT_ID && appConfig.RAT_SERVICE_ID) {
        sendEvent(appConfig.RAT_ACCOUNT_ID, appConfig.RAT_SERVICE_ID, data);
    }
}

function sendEvent(accountId, serviceId, data) {
    if (!window.RAT) {
        return;
    }

    window.RAT.addCustomEvent({
        accountId,
        serviceId,
        ...data,
    });
}
